const routes = [
  {
    index: true,
    label: 'Home',
    path: '/',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Blog',
    path: '/blog',
  },
  {
    label: 'Bookshelf',
    path: '/books',
  },
  {
    label: 'Gallery',
    path: '/gallery',
  },
];

export default routes;
